<router-outlet></router-outlet>
<app-toasts></app-toasts>
<app-callback-info></app-callback-info>
<app-before-unload></app-before-unload>